import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';

const BookmarkFilledIcon = (props) => <FontAwesomeIcon icon={faBookmark} {...props} />;

export default BookmarkFilledIcon;
